var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isLottery && _vm.hasReward)?_c('answer-reward'):(!_vm.isQuality && _vm.hasReward)?_c('answer-award'):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }